module.exports = __webpack_public_path__ + "assets/img/24_1076_big.361419df.jpg";